import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';

export interface WizardReviewProps {
  children: React.ReactNode;
  className?: string;
}

/** Review content belongs before the caller's write; no write is performed here. */
export function WizardReview({ children, className }: WizardReviewProps) {
  return (
    <div className={cn('space-y-4 text-body text-text-body', className)} data-wizard-review>
      {children}
    </div>
  );
}

export interface WizardResultProps {
  title: string;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

/** Render after the caller confirms success; actions and persistence stay external. */
export function WizardResult({ title, children, actions, className }: WizardResultProps) {
  return (
    <section
      className={cn('space-y-4 text-body text-text-body', className)}
      data-wizard-result
      aria-label={title}
    >
      <div className="flex items-center gap-2">
        <Check className="h-5 w-5 text-status-success-fg" aria-hidden="true" />
        <h2 className="font-body text-card-title font-semibold text-text-heading">{title}</h2>
      </div>
      {children}
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </section>
  );
}
